import type { CompanyPackagesDTO } from '@conversed/shared/src/central/dto/company';
import { PackageKeys } from '@conversed/shared/src/central/types/package.type';

export const DEFAULT_COMPANY_PACKAGES: CompanyPackagesDTO = Object.values(
  PackageKeys,
).reduce(
  (acc, key) =>
    Object.assign(acc, {
      [key]: { isActive: false, startDate: null, endDate: null },
    }),
  {} as CompanyPackagesDTO,
);
